import { render } from "./HelpSearchBar.vue?vue&type=template&id=10ec56bd&scoped=true&ts=true"
import script from "./HelpSearchBar.vue?vue&type=script&lang=ts"
export * from "./HelpSearchBar.vue?vue&type=script&lang=ts"

import "./HelpSearchBar.vue?vue&type=style&index=0&id=10ec56bd&lang=scss&scoped=true"

import exportComponent from "/Users/zhouyuan/work/project/cargpsweb-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ec56bd"]])

export default __exports__